<template>
    <div class="form-container">
        <ValidationObserver v-slot="{ invalid }">
            <div v-if="!showNextStep && !isDone" class="cc-form">
                <div class="cc-form__header"><b>{{placeholders.welcome}}<br /></b><img src="../assets/cc-icon.png" alt="cc-icon" class="cc-form__icon" /></div>
                <div v-if="countryCode == 'CCPA'" class="ccpa-box">
                    <div class="ccpa-header">Do Not Sell My Personal Information</div>
                    <p class="ccpa-contents">All California residents have the right to opt-out of the sale of their personal information under the California Consumer Privacy Act (CCPA).
                    To exercise this right, please fill out the form below, and we will process your request as required by law. Once your request is submitted, we will not sell your personal information unless you choose to opt-in at a later time.
                    If you have any questions or need assistance, you can contact our <a href="mailto:webform@customercare.today">Data Privacy team</a></p>
                </div>

                <p v-html="placeholders.provideDetails"></p>
                <div class="cc-form__fields">
                    <form @submit="handleSubmit">        
                        <span v-for="field in fields" :key="field">
                            <validation-provider v-if="field == 'first_name'" rules="required" v-slot="{ errors }">
                                <input :placeholder='placeholders.firstName' v-model="firstName" />
                                <span v-if="errors[0]" class="invalid-message">{{ placeholders.required }}</span>
                            </validation-provider>
                            <validation-provider v-if="field == 'last_name'" rules="required" v-slot="{ errors }">
                                <input :placeholder="placeholders.lastName" v-model="lastName" />
                                <span v-if="errors[0]" class="invalid-message">{{ placeholders.required }}</span>
                            </validation-provider>
                            <validation-provider v-if="field == 'email'" rules="required|email" v-slot="{ errors }">
                                <input :placeholder="placeholders.email" v-model="formModel.EMAIL" />
                                <span v-if="errors[0]" class="invalid-message">{{ placeholders.invalidMail }}</span>
                            </validation-provider>
                            <validation-provider v-if="field == 'phone'" rules="phone" v-slot="{ errors }">
                                <input :placeholder="placeholders.phoneNo" v-model="formModel.phonenumber" /><br />
                                <span v-if="errors[0]" class="invalid-message">{{ placeholders.invalidNumber }}</span>
                            </validation-provider>
                            <validation-provider v-if="field == 'usa_state'" rules="required">
                                <select v-model="formModel.state">
                                        <option class="state-placeholder" value="" disabled selected>{{placeholders.state}}</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select><br/>
                            </validation-provider>    
                            <a v-if="!invalid && verified && field == 'submit'" @click="goToNextStep">
                                <div class="cc-form__btn">{{placeholders.next}}</div>
                            </a>
                            <a v-else-if="field == 'submit'">
                                <div class="cc-form__btn invalid">{{placeholders.next}}</div>
                            </a>
                            <div v-if="field == 'privacy_policy_popup'">
                                <a href="#" @click.prevent="showModal = true" class="privacy-policy">Privacy Policy</a>
                                <modal v-if="showModal" @close="showModal = false"></modal>                  
                            </div>
                            <div v-if="field == 'privacy_policy_link'">
                                <a :href="placeholders.privacy_policy_link_href" class="privacy-policy" target="_blank">{{placeholders.privacy_policy_link_name}}</a>
                            </div>
                        </span>
                        <br/>
                        <a style="font-size: 14px; text-decoration: underline;" @click="showComplaintHub">Complaint hub</a>
                        <br/>
                        <div v-if="complaintHub" style="font-size: 12px; text-align: left;">
                            We'd love to hear from you! Reach out to us for any inquiries or feedback. We help consumers to use mobile phones and the Internet safely with a range of measures and precautions for end-users. The keyword here is responsibility. The use of new media is a topic that is not just relevant to the end-user of mobile phones. We work to enable people, whether young or older – to use new technologies safely and adheres to a minimum set of responsibilities. As such, creation, operation and promotion of these services are considered, with these persons in mind. Please reach out to us to have a view on the reports that were used to monitor the promotions and complaints. 
                        </div>
                        <br/>
                        <validation-provider rules="required">
                            <recaptcha v-on:recaptchaVerified="verified = true"></recaptcha>
                        </validation-provider>
                    </form>
                </div>
            </div>
            <div v-if="showNextStep && !isDone" class="cc-form">
                <div class="cc-form__header">
                    <b v-if="countryCode == 'US'">{{placeholders.optoutService}}</b>
                    <b v-else>{{placeholders.whatsUp}}, {{firstName}}?<br /></b>
                    <img src="../assets/cc-icon.png" alt="cc-icon" class="cc-form__icon" />
                </div>
                <form class="cc-form__fields">
                    <br />
                    <validation-provider rules="required" v-slot="{ errors }">
                        <textarea name="message" rows="50" cols="30" v-model="formModel.request"
                            :placeholder="placeholders.tellUs"></textarea>
                        <span v-if="errors[0]" class="invalid-message">{{placeholders.explainFeels}}</span>
                        <br>
                    </validation-provider>
                    <span><label>{{placeholders.unsubscribe}}</label></span><input type="checkbox" id="checkbox"
                        label="unsubscribe from our services" v-model="formModel.unsubscribe"><br />
                    <a v-if="!invalid" @click="handleSubmit">
                        <div class="cc-form__btn">{{placeholders.submit}}</div>
                    </a>
                    <a v-else>
                        <div class="cc-form__btn invalid">{{placeholders.submit}}</div>
                    </a>
                </form>
            </div>
        </ValidationObserver>
        <div v-if="isDone" class="cc-form">
            <div class="cc-form__header"><b>{{placeholders.thankYou}}, {{firstName}}!<br /></b>
            <img src="../assets/cc-icon.png" alt="cc-icon" class="cc-form__icon" /></div>
            <p v-if="formModel.unsubscribe">{{placeholders.unsubscribed}}</p>
            <p>{{placeholders.getBack}}<br/><br/>
             {{placeholders.bestRegards}} <br/>
            Customer Service Team</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import placeholders from '../lib/placeholders';
    import fields from '../lib/fields';
    import {baseUrl} from '../constants';
    import Recaptcha from './Recaptcha';
    import Modal from './Modal';

    // import UsStates from './UsStates';

    export default {
        name: 'Form',
        components: { Recaptcha, Modal },
        props: {
            sourceLanguage: {
                type: Object
            },
            targetLanguage: {
                type: Object
            }
        },
        data() {
            return {
                formModel: {
                    EMAIL: '',
                    fullname: '',
                    phonenumber: '',
                    request: '',
                    unsubscribe: false,
                    state: ''
                },
                firstName: '',
                lastName: '',
                showNextStep: false,
                isDone: false,
                verified: false,
                formLanguage: '',
                placeholders,
                fields,
                showModal: false,
                complaintHub: false
            }
        },
        computed: {
            countryCode: function() {
                return this.$router.currentRoute.path.replace(/\//g, "").toUpperCase();
            }
        },
        methods: {
            goToNextStep() {
                const { firstName, lastName } = this;
                if (firstName !== '' || lastName !== '') {
                    this.formModel.fullname = this.formModel.fullname.concat(firstName, ' ', lastName);
                }
                this.showNextStep = true
            },
            showComplaintHub() {
                this.complaintHub = !this.complaintHub;
            },
            handleSubmit() {
                this.isDone = true
                this.showNextStep = false;
                this.formModel.countryCode = this.countryCode;
                if (location.hostname != "localhost") {
                    this.sendMessage(this.formModel);
                }
                else {
                    console.log(this.formModel);
                }
            },
            async sendMessage(message) {
                await axios.post(`${baseUrl}/sendMail/`, message)
                           .then(response => console.log('message send!', response))
                           .then(() => {
                                if (message.unsubscribe) {
                                    this.unsubscribe(message)
                                }
                            })
                            .catch(err => console.error('Error sending message!', err))
            },
            unsubscribe(request) {
                const params = {
                    email_address: request.EMAIL,
                    phone: {
                        msisdn: request.phonenumber,
                        apiKey: "smsApiKey"
                    },
                }
                const {msisdn, apiKey} = params.phone
                
                axios.post('https://lpapi.pblinq.com/customerCare/emailUnsubscribe/', params.email_address)
                     .then(response => console.log('email unsubscribe request send!', response))
                     .catch(err => console.error('Error sending mail unsubscribe!', err))

                axios.post(`https://subapi.tech-lab.io/smsmarketing/blacklist/?msisdn=${msisdn}&apiKey=${apiKey}`)
                     .then(response => console.log('phone no. unsubscribe request send!', response))
                     .catch(err => console.error('Error sending phone unsubscribe!', err))
            },
            translate() {
                if (this.targetLanguage.hasOwnProperty('code')) {
                    const placeholderKeys = Object.keys(placeholders.default)
                    placeholderKeys.map(key => {
                        let url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${this.sourceLanguage.code}&tl=${this.targetLanguage.code}&dt=t&q=${placeholders.default[key]}`;
                        axios.get(url)
                            .then(response => {
                                this.placeholders[key] = response.data[0][0][0]
                            })
                            .catch(err => console.error(err))
                    })
                }
            }
        },
        created: function () {
            // Merge placeholders with optional country specific overrides
            let countryPath = this.$router.currentRoute.path.replace(/\//g, "").toUpperCase();
            Object.assign(this.placeholders.default, this.placeholders.hasOwnProperty(countryPath) ? this.placeholders[countryPath] : new Object());
            this.placeholders = this.placeholders.default;
            this.fields = fields.hasOwnProperty(countryPath) ? this.fields[countryPath] : this.fields.default;
        },
        watch: {
            targetLanguage: function() {
                this.translate()
            },
        },
    }
</script>

<style>
    .form-container {
        position: relative;
        font-size: 1.6rem;
        -ms-flex-line-pack: center;
        justify-items: center;
        background-color: white;
        border-radius: 10%;
        max-width: 500px;
        min-width: 500px;
        max-height: 800px;
        padding: 50px;
        margin: 10% 0;
        width: fit-content -webkit-fit-content;
        height: -webkit-fill-available;
    }

    .cc-form__header {
        margin-left: 100px;
    }

    .cc-form__icon {
        position: absolute;
        top: 35px;
        left: 50px;
    }

    .cc-form p {
        margin-top: 33px;
        font-size: 1rem;
        color: grey;
    }

    .cc-form__fields .cc-form__btn {
        background-color: #0072bc;
        color: white;
        font-size: 1.6rem;
        padding: 17px;
        margin-top: 25px;
        border-radius: 50px;
    }

    .cc-form__fields form,
    a {
        width: 100%;
        text-align: center;
        cursor: pointer;
    }

    .cc-form__fields input, .cc-form__fields select {
        width: 90%;
        height: 42px;
        margin: 5px 0;
        border: none;
        border-radius: 30px;
        background-color: whitesmoke;
        padding: 12.5px;
        padding-left: 25px;
        font-size: 1.2rem;
        font-weight: 100;
        text-align: left;
    }

    .cc-form__fields select {
        width: 100%;
        height: 67px;
    }

    .cc-form__fields select option {
        font-weight: 100;
    }

    .cc-form__fields input::placeholder {
        color: grey;
        font-size: 1rem;
    }

    .cc-form__fields textarea {
        width: 90%;
        height: 250px;
        border: none;
        border-radius: 30px;
        background-color: whitesmoke;
        padding: 25px;
        font-size: 1rem;
        font-weight: 100;
        text-align: left;
        resize: none;
    }

    .cc-form__fields label {
        font-size: 1rem;
    }

    .invalid-message {
        color: red;
        font-size: 1rem;
    }

    .invalid {
        background-color: grey;
    }

    .invalid:hover {
        background-color: rgba(0, 114, 188, .4);
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
    }

    #checkbox {
        width: 15%;
        height: auto;
        margin-left: 15px;
    }

    a.privacy-policy {
        font-size: 0.5em;
        color: grey;
    }

    @keyframes shake {

        10%,
        90% {
            transform: translate3d(0px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-2px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
    
    .ccpa-header {
        margin-top: 50px;
        font-size: 14px;
        font-weight: bold;
    }

    .ccpa-contents {
        font-size: 13px !important;
    }

    .ccpa-box {
        margin-bottom: 0px;
        height: auto;
    }

    @media only screen and (max-width : 640px) {
        .form-container {
            font-size: 1.4rem;
            border-radius: 0;
            min-height: 500px;
            min-width: 0;
        }

        .cc-form__header {
            margin-left: 75px;
        }

        #checkbox {
            width: 5%;
            height: auto;
        }
    }
</style>